import styled from 'styled-components';
export const Steps = styled.div `
  background-color: ${({ theme, values, index, step, disabled }) => {
    if (disabled) {
        if ((values.length === 1 && index * step < values[0]) ||
            (values.length !== 1 && index * step >= values[0] && index * step <= values[1]))
            return `rgba(${theme.colors.transparentWhite}, 0.36);`;
        return `rgba(${theme.colors.transparentBlack}, 0.16);`;
    }
    if ((values.length === 1 && index * step < values[0]) ||
        (values.length !== 1 && index * step >= values[0] && index * step <= values[1]))
        return `rgba(${theme.colors.transparentWhite}, 0.36);`;
    return `rgba(${theme.colors.transparentBlack}, 0.36);`;
}};
  height: 0.1875rem;
  min-height: 0.1875rem;
  width: 0.1875rem;
  border-radius: 50%;

  &:first-of-type,
  &:last-of-type {
    visibility: hidden;
  }
`;
